<template>
    <modal @before-open="beforeOpen"
           name="ActivityPlaceMapPopup"
           transition="nice-modal-fade"
           :min-width="360"
           :min-height="150"
           :pivot-y="0.4"
           :adaptive="true"
           :reset="true"
           height="auto"
           width="50%" style="margin-top:20px;">
        <div class="popupcontainer container">
            <div class="btn-close">
                <svg width="14px" height="14px" viewBox="0 0 12 12" xmlSpace="preserve" @click="$modal.hide('ActivityPlaceMapPopup')">
                    <line x1="1" y1="11" x2="11" y2="1" style="stroke-linecap: round; stroke-linejoin: round;"></line>
                    <line x1="1" y1="1" x2="11" y2="11" style="stroke-linecap: round; stroke-linejoin: round;"></line>
                </svg>
            </div>
            <div class="modalHeader">
                <h4 class="top_txt">
                    봉사 장소
                </h4>
            </div>
            <div class="row" style="padding: 1em;">
                <vue-daum-map
                        :appKey="appKey"
                        :center.sync="center"
                        :level.sync="level"
                        :mapTypeId="mapTypeId"
                        :libraries="libraries"
                        @load="onLoad"
                        @center_changed=""
                        @zoom_start=""
                        @zoom_changed=""
                        @bounds_changed=""
                        @click=""
                        @dblclick=""
                        @rightclick=""
                        @mousemove=""
                        @dragstart=""
                        @drag=""
                        @dragend=""
                        @idle=""
                        @tilesloaded=""
                        @maptypeid_changed=""
                        style="width:100%;height:400px;"/>
            </div>
            <p>{{placeName.placeName}}</p>
        </div>
    </modal>
</template>

<script>
    import VueDaumMap from 'vue-daum-map'

    export default {
        name: "ActivityPlaceMapPopup",
        components: {
            VueDaumMap
        },
        props: ['lat','lng'],
            /*{
            lat: {
                type: String,
                required: true
            },
            lng: {
                type: String,
                required: true
            }
        },*/
        data() {
            return {
                appKey: '2cc81857a738829d4eb1c2f31d85cf10', //
                center: {},//{lng:126.913772, lat:37.557718}, // 지도의 중심 좌표
                level: 3, // 지도의 레벨(확대, 축소 정도),
                mapTypeId: VueDaumMap.MapTypeId.NORMAL, // 맵 타입
                libraries: ['services'], // 추가로 불러올 라이브러리
                map: null, // 지도 객체. 지도가 로드되면 할당됨.
                placeName: "",

                //lat:'',
                //lng:''
            }
        },
        methods: {
            onLoad(map) {
                if(this.lat && this.lng) {
                    //map.setCenter(new kakao.maps.LatLng(this.lat,this.lng));
                    this.map = map

                    new kakao.maps.Marker({
                        position: map.getCenter(),
                        map: map
                    });
                } else {
                    console.log('no maps')
                }
            },
            beforeOpen (event) {
                this.center = {lat:event.params.lat, lng:event.params.lng};
                this.placeName = {placeName:event.params.placeName};
            },
        },
        mounted() {
        },
        created() {
            this.center = {lat:this.lat, lng:this.lng};
        },
    }
</script>

<style scoped>
    .popupcontainer {
        overflow-y: auto;
        max-height:600px;
        border-radius: 5px;
        background: #F7F7F7;
    }
    .btn-close {
        -webkit-user-select: none;
        -moz-user-select: none;
        -ms-user-select: none;
        user-select: none;
        position: absolute;
        right: 20px;
        top: 5px;
    }
    .btn-close line {
        stroke: grey;
        stroke-width: 2;
    }
    .btn-close:hover line {
        stroke: black;
    }
    .modalHeader {
        border-bottom: 1px solid #EEE;
        padding: 1em;
        text-align: left;
    }
    .modalFooter {
        position: absolute;
        bottom: 0;
        width: 100%;
        background-color: #F7F7F7;
    }

</style>